import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-settings', {
  key: 'admin-settings',
  label: 'Settings',
  getSteps: () => [
    introStep({
      title: 'School Settings',
      content:
        'Everything that controls how this school behaves: school profile, the academic calendar, classroom or programme structure, payment configuration, ticket categories, the result PDF template, matric number rules, ID cards and the AI assistant. Use the Custom Fields tab to add your own fields for students, staff and guardians (for example Blood Group, Genotype or NIN) — they appear on each profile and can be printed on documents. Each tab is its own settings page.',
    }),
  ],
});
